import { useFormContext } from "react-hook-form";
import { MembershipFormValues } from "@/types/system-setting/membership";
import { useEffect, useState } from "react";
import { facilitiesData } from "@/types";
import FacilityTableView from "./table";

const FacilityDetailsForm = () => {
  const [facilites, setFacilities] = useState<facilitiesData[]>([])

  const {
    setValue,
  } = useFormContext<MembershipFormValues>();

  useEffect(() => {
    if (facilites) {
      setValue("facilities", facilites)
    }
  }, [facilites])

  return (
    <div className="text-black h-full">
      <FacilityTableView setFacilities={setFacilities} />
    </div>
  );
};

export default FacilityDetailsForm;